/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Terms_Section_2_Term_Us_LinkInputs */

const en_terms_section_2_term_us_link = /** @type {(inputs: Terms_Section_2_Term_Us_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legal information`)
};

const lv_terms_section_2_term_us_link = /** @type {(inputs: Terms_Section_2_Term_Us_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rekvizīti`)
};

/**
* | output |
* | --- |
* | "Legal information" |
*
* @param {Terms_Section_2_Term_Us_LinkInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const terms_section_2_term_us_link = /** @type {((inputs?: Terms_Section_2_Term_Us_LinkInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Terms_Section_2_Term_Us_LinkInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_terms_section_2_term_us_link(inputs)
	return en_terms_section_2_term_us_link(inputs)
});